import { idColumn } from '@/shared/grids/columns/idColumn';
import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridSettings } from '@/shared/types/grid';

import { ChecklistTemplate } from '@prisma/client';

export const checklistTemplateGrid: GridSettings<ChecklistTemplate> = {
  defaultSort: {
    name: 'asc',
  },
  columns: [
    idColumn(),
    textColumn({
      header: 'Name',
      field: 'name',
      allowFiltering: false,
    }),
  ],
};
